import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import Text from './_text.js'
import Hideable from './_hideable.js'

export default {
  name: 'Notification',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
          height: 'auto',
          padding: '8px',
        },
      },
    },
    icon: {
      configSet: Image,
      configValues: {
        style: {
          minHeight: '16px',
          minWidth: '16px',
        },
      },
    },
    text: {
      configSet: Text,
      configValues: {},
    },
    $mixin: [
      {
        configSet: Hideable,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
